import APIClient from '../../services/APIClient';
import { makeApiCall } from '../../services/ApiService';

export default {

    createBigQueryQuery: (data: any) => makeApiCall({
        startCallMessage: 'API: Creating BigQuery Query Data',
        successMessage: 'API: Successfully created BigQuery Query Data',
        failureMessage: 'API: Creating BigQuery Query Failed',
        url: '/admin/bigquery-queries',
        method: APIClient.post,
        data,
        config: null,
        shouldShowNotifications: true,
        extractPath: (data) => data.bigqueryResult,
    }),


    getBigQueryQueries: (params: any) => makeApiCall({
        startCallMessage: 'API: Fetching BigQuery Queries Data',
        successMessage: 'API: Successfully Fetched BigQuery Queries Data',
        failureMessage: 'API: Fetching BigQuery Queries Failed',
        params,
        url: '/admin/bigquery-queries',
        method: APIClient.get,
        data: null,
        config: null,
        shouldShowNotifications: true,
        extractPath: (data) => data.bigqueryqueries,
    }),

    deleteBigQueryQueries: (data: any) => makeApiCall({
        startCallMessage: 'API: Deleting BigQuery Queries',
        successMessage: 'API: Deleting BigQuery Queries Success',
        failureMessage: 'API: Deleting BigQuery Queries Failed',
        data,
        url: '/admin/bigquery-queries/delete',
        shouldShowNotifications: true,
        method: APIClient.post,
        config: null,
        extractPath: (data) => data,
    }),

    editBigQueryQueries: (data: any) => makeApiCall({
        startCallMessage: 'API: Editing BigQuery Queries',
        successMessage: 'API: Editing BigQuery Queries Success',
        failureMessage: 'API: Editing BigQuery Queries Failed',
        data,
        shouldShowNotifications: true,
        url: '/admin/bigquery-queries' + (data._id ? `/${data._id}` : ''),
        method: APIClient.put,
        config: null,
        extractPath: (data) => data,
    }),

    runBigQuery: (data: any) => makeApiCall({
        startCallMessage: 'API: Fetching bigquery query data',
        successMessage: 'API: Successfully fetched BigQuery Query Data',
        failureMessage: 'API: Fetching BigQuery Query Failed',
        url: '/admin/bigquery-queries/query',
        method: APIClient.post,
        data,
        config: null,
        shouldShowNotifications: true,
        extractPath: (data) => data.bigqueryResult,
    }),

    getBigQuerySQL: () => makeApiCall({
        startCallMessage: 'API: Creating BigQuery Query Data',
        successMessage: 'API: Successfully created BigQuery Query Data',
        failureMessage: 'API: Creating BigQuery Query Failed',
        url: '/admin/bigquery-queries/queries',
        method: APIClient.get,
        data: null,
        config: null,
        shouldShowNotifications: false,
        extractPath: (data) => data.queries,
    })

}
